export { Marcadores } from './marcadores/marcadores.model';
